<template>
  <section class="c-quicklinks u-hide-mobile">
    <nav role="navigation" aria-label="Quick Link Navigation">
      <ul class="listless inline c-quicklinks--user" v-if="quickLinks.length > 0">
        <li v-for="(link, index) in quickLinks" :key="index">
          <span
            v-if="index <= 2"
            @click="gotoLink(link)"
            tabindex="0"
            @keyup.enter="gotoLink(link)"
          >{{link.name}}</span>
        </li>
        <li>
          <dropdown :is-open="false">
            <dropdown-action
              v-for="link in additionalLinks"
              :key="link.id"
              @click="gotoLink(link)"
              @keyup.enter="gotoLink(link)"
              tabindex="0"
            >{{link.name | truncate(15)}}</dropdown-action>
            <dropdown-action @click="addNewLink = true" tabindex="0">Add Current Page</dropdown-action>
            <dropdown-action
              @click="$router.push({path: '/profile/quicklinks'})"
              tabindex="0"
            >Manage Links</dropdown-action>
            <dropdown-action @click="addQrCode = true">Generate QR Code</dropdown-action>
          </dropdown>
        </li>
      </ul>

      <ul class="listless inline c-quicklinks--user new" v-else>
        <li>
          <dropdown :is-open="false">
            <dropdown-action @click="addNewLink = true">Add Current Page</dropdown-action>
            <dropdown-action @click="$router.push({path: '/profile/quicklinks'})">Manage Links</dropdown-action>
            <dropdown-action @click="addQrCode = true">Generate QR Code</dropdown-action>
          </dropdown>
        </li>
      </ul>
      <ul class="listless inline c-quicklinks--external" v-if="displayHeaderLinks.length > 0">
        <li v-for="(system,index) in displayHeaderLinks" :key="system.id">
          <div class="c-quicklinks__image" v-if="index < 8">
            <base-tooltip :text="`${system.name}`">
              <span @click="gotoLink(system)" tabindex="0" @keyup.enter="gotoLink(system)">
                <image-loader :image-id="system.icon_id" :alt="`Logo for ${system.name}`" />
              </span>
            </base-tooltip>
          </div>
        </li>
        <li>
          <dropdown :isOpen="false" @keyup.enter="viewAllExternals">
            <dropdown-action @click="viewAllExternals">View more</dropdown-action>
          </dropdown>
        </li>
      </ul>
    </nav>

    <modal v-if="addNewLink" class="ta-left" show-close-button @close="addNewLink = false">
      <h1 slot="header">Add Quick Link</h1>
      <form method="post" v-on:submit.prevent>
        <form-field full-width label="Title" name="name" type="text" v-model="newLink.name"></form-field>

        <form-field
          full-width
          label="Link"
          name="url"
          type="text"
          v-model="currentLink"
          :value="currentLink"
        ></form-field>

        <base-button type="submit" @click="onSubmit">Add Link</base-button>
      </form>
    </modal>
    <modal v-if="addQrCode" show-close-button @close="addQrCode = false" class="ta-left">
      <h1 slot="header">Create QR Code</h1>
      <qr-generator />
    </modal>
  </section>
</template>

<script>
import Dropdown from "@/components/Dropdown";
import DropdownAction from "@/components/DropdownAction";
import { mapState, mapGetters } from "vuex";
import { ImageLoader } from "@/components/elements";
import QrGenerator from "@/components/contentElements/modals/TheQrGenerator"
export default {
  name: "QuickLinks",

  computed: {
    ...mapState("users", ["quickLinks"]),
    additionalLinks() {
      return this.quickLinks.filter((val, index) => index > 2);
    },
    currentLink() {
      return this.$route.path;
    }
  },

  methods: {
    //because why would we want links to work as links in dropdown actions?
    viewAllExternals() {
      this.$router.push({ name: "ExternalSystems" });
    },
    gotoLink(link) {
      const a = document.createElement("a");
      a.id = "generatedLink";
      a.href = link.url || link.link;
      a.target =
        a.href.includes("http") && !a.href.includes(window.location.host)
          ? "_blank"
          : "_self"; // Do we want to open in a new window?
      a.rel = "noopener nofollow external";
      a.click();
    },

    onSubmit() {
      this.newLink.url = this.currentLink;
      this.$store.dispatch("users/addQuickLink", this.newLink).then(resp => {
        this.$store.dispatch("users/getQuickLinks").then(resp => {
          this.addNewLink = false;
          //set an alert, close modal?
          this.$store.dispatch(
            "notifications/create",
            {
              body: `Your quick links have been updated`,
              type: "success"
            },
            { root: true }
          );
        });
      });
    },

    setFileData(blob) {
      const vm = this;
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    ImageLoader,
    QrGenerator
  },

  data() {
    return {
      newLink: {
        name: "",
        url: "",
        icon: "link"
      },
      addNewLink: false,
      addQrCode: false,
      displayHeaderLinks: []
    };
  },

  beforeCreate() {
    this.$store.dispatch("users/getQuickLinks");
    this.$store.dispatch("systems/getExternalHeaderLinks").then(resp => {
      this.displayHeaderLinks = resp;
    });
  }
};
</script>

<style lang="scss">
.c-quicklinks {
  .c-dropdown__toggle {
    border-radius: 4px !important;
    background: $colour-nhs-white;
  }

  &--external {
    .c-dropdown {
      width: 41px;
      height: 41px;

      width: 41px;
      height: 41px;

      &__toggle {
        border-radius: 100% !important;
        line-height: 41px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.c-quicklinks {
  float: right;
  text-align: right;
  // width: 50vw;
  max-width: 1400px;
  margin: 1em auto;
  // margin-right: 1em;
  ul {
    display: inline-flex;
    justify-content: flex-end;

    &:last-of-type {
      margin-left: 18px;
    }
  }

  &--user {
    li {
      margin-right: 4px;
      text-align: left;
      position: relative;
      display: inline-flex;
      max-width: 134px;
      height: 50px;
      align-items: center;
      background: $colour-nhs-white;

      border-radius: 4px;
      text-decoration: none;
      transition: all ease-in-out 0.2s;

      &:hover {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.11);
      }

      &:after {
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
        content: "";
        width: 20px;
        height: 100%;
        z-index: 0;
        position: absolute;
        top: 0;
        right: 0;
        pointer-events: none;
        border-radius: 4px;
      }

      &:last-of-type {
        margin-right: 0;
      }

      // width: 134px;
      // max-width: 134px;
      // overflow: hidden;
      span {
        padding: 10px;
        display: block;
        max-width: 134px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: $colour-nhs-dark-grey;
        text-decoration: none;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
  }

  &--external {
    background: $colour-nhs-white;
    border-radius: 80px;
    padding: 5px;

    li {
      margin-right: 5px;

      &:last-of-type {
        margin-right: 0;
      }

      span {
        cursor: pointer;
      }
    }

    img {
      width: 41px;
      height: 41px;
      border-radius: 100%;
      max-width: 41px;
      max-height: 41px;
      // overflow: hidden;
      @supports (object-fit: cover) {
        min-height: 41px;
        width: 100%;
        min-width: 41px;
        height: 100%;
        object-fit: cover;
        max-width: 41px;
        max-height: 41px;
      }

      transition: all ease-in-out 0.1s;

      @media (hover: hover) {
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>